export const EmptyTagsTypes = {
    EmptyTag: [
        '<p></p>',
        '<h1></h1>',
        '<h2></h2>',
        '<h3></h3>',
        '<h4></h4>',
        '<h5></h5>',
        '<h6></h6>',
        '<blockquote></blockquote>',
        '<pre></pre>',
        '<p><br></p>',
        '<h1><br></h1>',
        '<h2><br></h2>',
        '<h3><br></h3>',
        '<h4><br></h4>',
        '<h5><br></h5>',
        '<h6><br></h6>',
        '<blockquote><br></blockquote>',
        '<pre><br></pre>'
    ]
}